import React from 'react';
import PaymentGatewayTesterStore from './stores/PaymentGatewayTesterStore';
import PaymentGatewayTesterActions from './actions/PaymentGatewayTesterActions';
import PaymentGatewayTesterGateway from './PaymentGatewayTesterGateway';

class PaymentGatewayTester extends React.Component {

  constructor(props) {
    super(props)
    this.state = this.getStateFromStores();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    PaymentGatewayTesterStore.addChangeListener(this._onChange);
    PaymentGatewayTesterActions.init(this.props);
  }

  getStateFromStores() {
    return {
      gateways: PaymentGatewayTesterStore.getGateways(),
      gatewayOptions: PaymentGatewayTesterStore.getGatewayOptions(),
      readOnly: PaymentGatewayTesterStore.getReadOnly(),
      property_id: PaymentGatewayTesterStore.getPropertyId(),
    }
  }

  render() {
    if (this.state.gateways && this.state.gateways.length > 0) {
      var paymentGateways = this.state.gateways.map((gateway) => {
        return <PaymentGatewayTesterGateway date_format={this.props.date_format} time_format={this.props.time_format} key={gateway.id} gateway={gateway} property_id={this.state.property_id} property={this.props.property} gatewayOptions={this.state.gatewayOptions} readOnly={this.state.readOnly} />
      });
    }

    return (
      <div className="paymentGatewayTester">
        {this.props.readOnly || this.state.gateways.length > 0 ? null : <div className="actions">
          <button className="btn btn-primary" onClick={PaymentGatewayTesterActions.newGateway}>{I18n.t('new_payment_gateway')}</button>
        </div>}
        {paymentGateways && paymentGateways.length ? paymentGateways : <div className="jumbotron" style={{marginBottom: '0px'}}><h2 style={{ margin: 10 }} className="text-center"><span className="none">{I18n.t('none')}</span></h2></div>}
        <div className="loadingOverlay"><div className="spinner" /></div>
      </div>
    );
  }

  _onChange() {
    this.setState(this.getStateFromStores());
  }

}

export default PaymentGatewayTester
